import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { RateThisAppElementContentModel } from '@/services/platform/api/model';
import { cn, LinksToLinkMap, ModuleProperties } from '@/lib/core';
import ModuleWrapper from '@/components/shared/module/wrapper';
import { useUIStore } from '@/lib/core/stores';

export const RateThisApp = (props: ModuleProperties) => {
  const content = props.content as RateThisAppElementContentModel | undefined;
  const p = content?.properties;
  const setHideNavbar = useUIStore(state => state.setHideNavbar);
  const navigate = useNavigate();

  useEffect(() => {
    setHideNavbar(true);
    return () => setHideNavbar(false);
  }, [setHideNavbar]);

  const appleStoreHref = LinksToLinkMap(p?.appStoreAppLink ?? undefined)?.href;
  const playStoreHref = LinksToLinkMap(p?.playStoreAppLink ?? undefined)?.href;

  useEffect(() => {
    let url: string | undefined;

    switch (Capacitor.getPlatform()) {
      case 'android':
        url = playStoreHref;
        break;
      case 'ios':
        url = appleStoreHref;
        break;
      default:
        url = playStoreHref;
    }

    async function open() {
      if (url) {
        if (Capacitor.isNativePlatform()) {
          await Browser.open({ url });
        } else {
          window.open(url, '_blank');
        }
      }
      navigate(-1);
    }

    open();
  }, [appleStoreHref, playStoreHref, navigate]);

  if (!content) return null;

  return (
    <ModuleWrapper
      component={props}
      classNames={{
        base: cn(['module__rate-this-app']),
        container: cn(['flex-1']),
        wrapper: cn(['py-0', 'flex-1']),
        grid: cn(['flex flex-col flex-1 gap-0']),
      }}
      isFullWidth={true}
      {...props}
    >
      {null}
    </ModuleWrapper>
  );
};
